import { z } from 'zod';

import { requiredString } from '@utils/validation';

export const schema = z.object({
	memberInsuranceInfo: requiredString(''),
});
